// import update from './update.js';
import Reveal from "reveal.js";
import Markdown from "reveal.js/plugin/markdown/markdown.esm.js";
import "reveal.js/dist/reveal.css";
import "./theme.scss";

// even though Rollup is bundling all your files together, errors and
// logs will still point to your original source modules
// console.log('if you have sourcemaps enabled in your devtools, click on main.js:5 -->');

// update();

mapboxgl.accessToken =
    "pk.eyJ1IjoibG1jZ2FydGxhbmQiLCJhIjoiY2tncWo1Ym4xMGppdzMwa2w0MXF3MWRmeCJ9.YZO5TCmDL1ZQsDtJS9jkvg";

Reveal.initialize({ slideNumber: true, plugins: [Markdown] }).then(() => {
  
});

Reveal.on("slidetransitionend", (event) => {
  
  console.log(event);

  if(event.currentSlide.id == "locations"){
    var map = new mapboxgl.Map({
      center: [-96.771556, 35.967243],
      zoom: 3.2,
      container: "map",
      style: "mapbox://styles/mapbox/streets-v11",
    });

    
    var stCharlesMarker = new mapboxgl.Marker({color: "#FF4019"})
    .setLngLat([-90.5506899, 38.7950282])
    .addTo(map);

    var losAngelesMarker = new mapboxgl.Marker({color: "#FF4019"})
    .setLngLat([-118.2873057, 34.0223519])
    .addTo(map);

    var denverMarker = new mapboxgl.Marker({color: "#FF4019"})
    .setLngLat([-104.9951953, 39.7642548])
    .addTo(map);

    var oceansideMarker = new mapboxgl.Marker({color: "#FFCC00"})
    .setLngLat([-117.3733986, 33.1962499])
    .addTo(map);

    
  }

});